module.exports = __webpack_public_path__ + "img/brown-book.8df996a8.jpg";